module.exports = __webpack_public_path__ + "bo.5f3fef091d666ea0ed09.svg";


//////////////////
// WEBPACK FOOTER
// C:/Angular/projetos/RetycargasOfficialSite/src/assets/vendor/flag-icon-css-master/flags/4x3/bo.svg
// module id = ../../../../../src/assets/vendor/flag-icon-css-master/flags/4x3/bo.svg
// module chunks = styles